import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { Stack } from '../../../components/Stack';
import { useAppLayoutContext } from '../AppLayout.context';
import { appLayoutHeaderStyles } from './AppLayoutHeader.styles';
export const AppLayoutHeader = forwardRef(function AppLayoutHeader(props, forwardedRef) {
    const { styles, sx, children, divider, ...other } = props;
    const appLayoutContext = useAppLayoutContext();
    const { combineStyles, globalStyles } = useStyles({
        name: 'AppLayoutHeader',
        styles: [appLayoutHeaderStyles, styles],
    });
    const hasHeader = appLayoutContext.components.includes('header');
    const hasHeaderOpened = hasHeader;
    if (!hasHeaderOpened) {
        return null;
    }
    return (_jsx(Stack, { as: 'header', horizontal: true, justify: 'space-between', ...other, sx: [globalStyles, combineStyles('host', divider && 'host$divider'), sx], ref: forwardedRef, children: children }));
});
